// assets/slanted-panels.js
// Desktop hover is handled by pure CSS :has().
// JS handles mobile tap expand and Theme Editor design-mode events only.

if (!customElements.get('slanted-panels')) {
  class SlantedPanels extends HTMLElement {
    connectedCallback() {
      this._panels = Array.from(this.querySelectorAll('.s-slanted-panels__panel'));

      // Click to expand on all devices
      this._panels.forEach((panel) => {
        panel.addEventListener('click', () => {
          const isActive = panel.classList.contains('s-slanted-panels__panel--active');
          this._clearActive();
          if (!isActive) panel.classList.add('s-slanted-panels__panel--active');
        });
      });

      // Theme Editor hooks
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail.sectionId !== this._sectionId()) return;
        this._clearActive();
        const defaultIndex = parseInt(this.dataset.defaultOpen, 10) || 0;
        const target = defaultIndex > 0 ? this._panels[defaultIndex - 1] : null;
        if (target) target.classList.add('s-slanted-panels__panel--active');
      });

      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail.sectionId !== this._sectionId()) return;
        this._clearActive();
      });

      document.addEventListener('shopify:block:select', (e) => {
        const panel = this.querySelector(`[data-block-id="${e.detail.blockId}"]`);
        if (panel) {
          this._clearActive();
          panel.classList.add('s-slanted-panels__panel--active');
        }
      });

      document.addEventListener('shopify:block:deselect', () => {
        this._clearActive();
      });
    }

    _clearActive() {
      this._panels.forEach((p) => p.classList.remove('s-slanted-panels__panel--active'));
    }

    _sectionId() {
      return this.closest('[id]')?.id ?? null;
    }
  }

  customElements.define('slanted-panels', SlantedPanels);
}
